import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-236" data-mp="3hfcxe7wiwooc">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-237" data-mp="3r78x1ne9cmuo" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-12 sm:py-16" data-id="element-238" data-mp="y4ygr86wfh">
      <div className="mx-auto max-w-4xl" data-id="element-239" data-mp="41rqj3h73z57">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-240" data-mp="44w0yil97r4b">
          What Doctors Are Saying
        </h2>
        <p className="mt-3 text-center text-[14px] font-semibold text-ink/65 sm:text-base" data-id="element-241" data-mp="dzxs1jz3b39j">
          More than 2,000 professionals already using the methodology.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-242" data-mp="2fru02jm1tuzk">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-3xl border border-navy/10 bg-white p-5" data-id="element-243" data-mp="1sl2nlxb0rw13">
              <Stars data-id="element-244" data-mp="1nrpzrpe5zt9e" />
              <blockquote className="mt-3 text-[14px] font-medium italic leading-relaxed text-ink/80" data-id="element-245" data-mp="1iupuvht1wwjv">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-246" data-mp="1euz61jn34qhz">
                <img src={item.image} alt={`Portrait of ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-forest-mid/25" loading="lazy" data-id="element-247" data-mp="2bic3j4h4yrdl" />
                <div data-id="element-248" data-mp="1xjm6foubgrp8">
                  <p className="text-[14px] font-extrabold text-navy-deep" data-id="element-249" data-mp="1xkf8icibyt11">{item.name}</p>
                  <p className="text-[12px] font-medium text-ink/60" data-id="element-250" data-mp="r436g0ce0r06">{item.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-251" data-mp="nlmj60xuqrot">
          <CTAButton label="Join 2,000+ doctors" sub="Instant Access · One-time payment of $27 USD" data-id="element-252" data-mp="nmxlrxfk9tec" />
        </div>
      </div>
    </section>;
}